export const getPairChatPath = pairChatId => (pairChatId ? `/messages/pair/${pairChatId}` : '/messages');

/**
 * True when `path` is an absolute messages route.
 *
 * The leading slash is load-bearing: a relative 'messages' string is what the
 * backend used to echo before EC-26, and that value must not be treated as a
 * real destination.
 */
export const isMessagesPath = path => typeof path === 'string' && /^\/messages(\/|\?|$)/.test(path);

/**
 * Navigates to `path` after a successful login.
 *
 * Messages routes need a full page load, not a client-side navigate: the chat
 * socket is bootstrapped at page load, so an SPA transition leaves the
 * conversation without live updates.
 *
 * Deliberately a single location.assign rather than navigate() + reload().
 * The app uses createBrowserRouter, whose navigate() is async, so reload() can
 * fire while the history update is still pending — reloading the *current*
 * URL. After MFA that URL is /mfa with no query string, and PublicRouter then
 * sends the now-authenticated user to /home, dropping the deep link.
 *
 * @param {Function} navigate react-router navigate
 * @param {string} path
 */
export const navigateAfterLogin = (navigate, path) => {
  if (isMessagesPath(path)) {
    window.location.assign(path);
    return;
  }
  navigate(path);
};
